import { ReactNode, useRef } from 'react';
import { ErrorMessage, Label } from '@iwoca/orion';
import { DateTimePicker } from 'components/DatePicker/DateTimePicker';
import { Controller, useFormContext } from 'react-hook-form';
import { dateToString } from 'utils/common/common';

import styles from './DateField.module.css';

type TProps = {
  fieldName: string;
  label: (text: ReactNode) => ReactNode;
  error?: string;
};

export const DateField = ({ fieldName, label, error }: TProps) => {
  const { control } = useFormContext();
  const dateInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.dateField}>
      <Label>{label('Last repayment date')}</Label>
      <Controller
        name={`${fieldName}.lastRepaymentDate`}
        control={control}
        shouldUnregister
        render={({ field: { value, onChange } }) => (
          <DateTimePicker
            withInput
            defaultDate={value}
            dateInputRef={dateInputRef}
            filterDate={() => true}
            handleChange={(date) => onChange(date ? dateToString(date) : '')}
          />
        )}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};
